<template>
   <hic-dialog append-to-body @open="openEditor" :close-on-click-modal="false" :visible="visible" width="30rem" :title="!value.id ? '房间新增' : '房间编辑'"  @close="cancel">
    <el-form style="padding: 30px 60px 30px 0px" label-position="right" :inline="false" ref="editor" label-width="130px" :rules="comRules" :model="value">
      <el-row>
        <el-col :span="24">
          <el-form-item label="科室" prop="deptCode">
            <hic-dept-selector  v-model="value.deptCode"  style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="名称" prop="name">
            <el-input ref="nameIpt" type="text" placeholder="请输入" v-model.trim="value.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="编码" prop="code">
            <el-input type="text" placeholder="请输入" v-model.trim="value.code" :disabled="!!value.id" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="memo">
            <el-input type="textarea" placeholder="请输入" :rows="3" v-model.trim="value.memo" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
      <el-button v-if="!value.id" type="primary" @click="saveAndNext" :disabled="disabledSaveAndNext">保存并继续新建</el-button>
      <el-button type="primary" @click="save" :loading="disabledSave">确 定</el-button>
    </div>
   </hic-dialog>

</template>
<script>
  import api from "./api";
  export default {
    props: {
      value: {},
      visible: { type: Boolean, default: false },
    },
    data() {
      return {
        comRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" },
            { max: 128, message: "名称长度在 128 个字符以内", trigger: "blur" },
          ],
          code: [
            { required: true, message: "请输入编码", trigger: "blur" },
            { max: 64, message: "编码长度在 64 个字符以内", trigger: "blur" },
          ],
          deptCode: [
            { required: true, message: "请输入科室编码", trigger: "blur" },
            { max: 64, message: "编码长度在 64 个字符以内", trigger: "blur" },
          ],
        },
        disabledSave: false,
        autoNext: false,
        disabledSaveAndNext: false,
      };
    },
    methods: {
      saveAndNext() {
        this.autoNext = true;
        this.save();
      },
      openEditor() {
        this.disabledSave = false;
        if (this.$refs.editor) {
          this.$refs.editor.clearValidate();
        }
      },
      save() {
        let _this = this;
        // if (!this.value.id) {
        //   this.comRules.securityCode[0].required = true
        // } else{
        //   this.comRules.securityCode[0].required = false
        // }
        this.$refs.editor.validate((valid) => {
          if (valid) {
            this.disabledSave = true;
            api
              .DeptRoom.save(this.value)
              .then((res) => {
                _this.$message.success("保存成功!");
                _this.$emit("ok");
                if (!this.autoNext) {
                  _this.$emit("update:visible", false);
                } else {
                  this.autoNext = false;
                  this.value.id = null;
                  this.$refs.nameIpt.focus();
                }
              })
              .catch((err) => {
                if (err) {
                  _this.$message.error(err.message || err);
                }
              })
              .finally(() => {
                _this.disabledSave = false;
              });
          }
        });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
    },
  };
</script>
